import { Colors, Services } from '@sigma-frontend-libs/commons'

import { buttonModes, components } from '@/utils'

import button from '@/components/button'
import preloader from '@/components/preloader'

function renderPreloader(h) {
  return h(
    'div',
    {
      class: 'preloader__holder pa-2'
    },
    [
      h(
        preloader,
        {
          props: {
            size: 18
          }
        }
      )
    ]
  )
}

function renderCheckbox(h) {
  return h(
    components.checkbox,
    {
      props: { value: this.proxy },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    }
  )
}
function renderLink(h) {
  return h(
    'div',
    {
      class: 'link link--dashed',
      on: {
        click: () => {
          this.showDialog = true
        }
      }
    },
    [ this.getTranslate(`${Services.payments}.hints.offer`) ]
  )
}
function renderDialog(h) {
  return h(
    components.dialog,
    {
      props: {
        value: this.showDialog,
        maxWidth: 1000
      },
      on: {
        input: event => {
          this.showDialog = event
        }
      }
    },
    [
      h(
        'div',
        {
          class: 'pa-2',
          domProps: { innerHTML: this.html }
        }
      ),
      h(
        'div',
        {
          class: 'dialog__footer',
          slot: 'footer'
        },
        [
          h(
            button,
            {
              props: {
                label: this.getTranslate('misc.buttons.close'),
                mode: buttonModes.flat
              },
              on: {
                click: () => {
                  this.showDialog = false
                }
              }
            }
          ),
          h(
            button,
            {
              props: {
                label: this.getTranslate('misc.buttons.accept'),
                color: Colors.primary
              },
              on: {
                click: () => {
                  this.proxy = true
                  this.showDialog = false
                }
              }
            }
          )
        ]
      )
    ]
  )
}

export default function(h) {
  if (this.loading) {
    return renderPreloader.call(this, h)
  }
  if (typeof this.html === 'string') {
    return h(
      'div',
      {
        class: `${Services.payments}-offer`
      },
      [
        renderCheckbox.call(this, h),
        renderLink.call(this, h),
        renderDialog.call(this, h)
      ]
    )
  }
}
